import { ConfirmPopupVariant } from "../types/popup";

export const getTitleColor = (variant?: ConfirmPopupVariant) => {
  switch (variant) {
    case "delete":
      return "#FF6464";
    case "empty":
      return "#69E4FF";
    default:
      return "#ffffff";
  }
};

export const getMessageColor = (variant?: ConfirmPopupVariant) => {
  switch (variant) {
    case "delete":
    case "empty":
      return "#ffffff";
    default:
      return "#CACDCE";
  }
};
